<template>
	<modal
		:modal-id="modalId"
        :modal-size="'extra-large'"
        :modal-alignment="'top'"
        :is-need-button-footer="false"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-table
                :id="tableId"
                :options="options"
            />
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import {DetailUsagesDeductionsSchema} from './DetailUsagesDeductionsSchema';

export default {
	name: "DetailUsagesDeductionsModal",
	mixins: [FormMixin, ModalMixin, DetailUsagesDeductionsSchema],
	props: {
        tableId: String,
		formId: String,
        value: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: "Detail Usages Deductions - " + this.value.name,
		};
	},
	created() {
        this.options.columns = [...this.tableColumns];
	},
	methods: {
		submit() {
            this.inputs.product_category_id = 3

			if (this.selectedUrl) {
				this.inputs.created_at = this.formattedDate(this.inputs.created_at)
				? this.formattedDate(this.inputs.created_at)
				: this.formattedDate(new Date());
				this.inputs.updated_at = this.formattedDate(new Date());
				this.inputs.center_id = this.input_center.id;
				this.inputs.created_by = this.inputs.created_by.id;
				this.inputs.updated_by = this.inputs.updated_by.id;
			}

			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.price = this.inputs.price
				? this.inputs.price.toString().split(".")[0]
				: "";
			this.input_center = {
				id: this.inputs.center_id.id,
				name: this.inputs.center_id.name,
				is_active: this.inputs.center_id.is_active,
			};
			this.read_only_clc_id_number = this.inputs.clc_id_number;
			this.preloader = false;
		},
		setProductCategory(data) {
			this.inputs.product_category_id = this.inputs.product_category_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_category_id = data.id;
			}
		},
		setProductType(data) {
			this.inputs.product_type = this.inputs.product_type;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_type = data.id;
			}
		},
		setCenter(data) {
			this.inputs.center_id = this.inputs.center_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		},
		setClcIdNumber(data) {
			this.inputs.clc_id_number = this.inputs.clc_id_number;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.clc_id_number = data.clc_id_number;
			}
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const hour = date.getHours().toString().padStart(2, "0");
			const minute = date.getMinutes().toString().padStart(2, "0");
			const second = date.getSeconds().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

			return formattedDate;
		},
	},
};
</script>
